import React, { useEffect, useRef, useState } from "react";
import apiRoutes from "../../api/apiRoutes";
import { apiFetchJson } from "../../utils/http";

/**
 * IvaSelect (REUTILIZABLE)
 *
 * Props:
 * - value: { id, label } | null
 * - onChange: (iva|null) => void
 * - disabled?: boolean
 * - autoLoad?: boolean (default true)
 */
export default function IvaSelect({
  value,
  onChange,
  disabled = false,
  autoLoad = true,
}) {
  const boxRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // =========================
  // CLICK FUERA
  // =========================
  useEffect(() => {
    const outside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", outside);
    return () => document.removeEventListener("mousedown", outside);
  }, []);

  // =========================
  // LOAD (AUTOCOMPLETE IVA)
  // =========================
  const load = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const data = await apiFetchJson(apiRoutes.ivas.autocomplete);

      // backend devuelve AutoPageDto
      const list = data?.items || [];

      setItems(
        list.map((it) => ({
          id: it.id,
          label: it.nombre, // IVA_NM_IVA
        }))
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // AUTOLOAD (al montar vista)
  // =========================
  useEffect(() => {
    if (autoLoad && items.length === 0) {
      load();
    }
    // eslint-disable-next-line
  }, [autoLoad]);

  const openDropdown = () => {
    if (disabled) return;
    setOpen(true);
  };

  return (
    <div ref={boxRef} className="relative">
      <div
        className={`input flex items-center ${
          disabled ? "opacity-60" : "cursor-pointer"
        }`}
        style={{ minHeight: 42 }}
        onClick={openDropdown}
      >
        {value ? (
          <span>{value.label}</span>
        ) : (
          <span className="text-gray-400">
            -- Seleccionar IVA --
          </span>
        )}
      </div>

      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white border rounded shadow max-h-64 overflow-auto">
          <div
            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-600"
            onClick={() => {
              onChange?.(null);
              setOpen(false);
            }}
          >
            -- Todos --
          </div>

          {items.map((it) => (
            <div
              key={it.id}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onChange?.(it);
                setOpen(false);
              }}
            >
              {it.label}
            </div>
          ))}

          {!loading && items.length === 0 && (
            <div className="px-3 py-2 text-gray-400">
              Sin resultados
            </div>
          )}
        </div>
      )}
    </div>
  );
}
